export const languageIds = {
    enUS: 'enUS', // US English
    enGB: 'enGB', // European Engilsh
    frCA: 'frCA', // French Canadian
    frFR: 'frFR', // French
    esES: 'esES', // Spanish
    deDE: 'deDE', // German
    ptPT: 'ptPT', // Portuguese,
    hrHR: 'hrHR', // Croatian,
    itIT: 'itIT', // Italian
};



// WEBPACK FOOTER //
// ./src/lib/localization/languageIds.js